
import React from 'react';

interface SimpleRecommendationItemProps {
  text: string;
}

const SimpleRecommendationItem: React.FC<SimpleRecommendationItemProps> = ({ text }) => {
  return (
    <div className="pl-4 pr-4 py-1 text-sm text-muted-foreground">
      • {text}
    </div>
  );
};

export default SimpleRecommendationItem;
